import * as types from '../actions/types'
import Immutable from 'immutable'

const INITIAL_STATE = Immutable.fromJS({
    username: '',
    password: '',
    processing: false,
    isAuthenticated: false,

})

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.INICIAR_SESION:
            state = state.set('isAuthenticated', true)
            return state
        case types.CERRAR_SESION:
            state = state.set('isAuthenticated', false)
            return state
        case types.MODIFICAR_INPUTS_SIGNIN_PAGE:
            state = state.set(action.payload.attr, action.payload.value)
            return state
        case types.PROCESAMIENTO_SIGNIN_PAGE:
            state = state.set('processing', action.payload)
            if (!action.payload) {
                state = state.set('password', '')
            }
            return state
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/auth.js